import API from '../requests/sys';

/** 获取助教求助信息 */
export async function profile(): Promise<any> {
  try {
    const res = await API.profile();
    return { ...res.data, login: true };
  } catch (error) {
    return { login: false };
  }
}
